import { render, staticRenderFns } from "./soft-application.vue?vue&type=template&id=e939bb32&scoped=true&"
import script from "./soft-application.vue?vue&type=script&lang=js&"
export * from "./soft-application.vue?vue&type=script&lang=js&"
import style0 from "./soft-application.vue?vue&type=style&index=0&id=e939bb32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e939bb32",
  null
  
)

export default component.exports